import { NewsList } from "@/@types";
import { ROUTES } from "@/config/routes";
import Link from "next/link";
import { FallbackImage } from "../common";
import NoContent from "../common/NoContent";
import IconSprite from "../common/IconSprite";

type Props = {
  newsList?: NewsList;
  categorySlug?: string;
};

export default function NewsListCard({ newsList, categorySlug }: Props) {
  if (!newsList || newsList.news.length === 0) {
    return (
      <NoContent />
    );
  }

  return (
    <div className="grid grid-cols-2 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {newsList.news.map((singleNews) => {
        const formatDate = new Date(singleNews.date)
          .toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .toUpperCase();

        const newsLink = categorySlug
          ? ROUTES.news.details(categorySlug, singleNews.slug)
          : ROUTES.news.details(singleNews.categorySlug, singleNews.slug);

        return (
          <Link
            key={singleNews.slug}
            href={newsLink}
            className="border bg-white shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
          >
            <div className="aspect-video">
              <FallbackImage
                width={550}
                height={275}
                src={singleNews.imageUrl || "/images/img_no_found.jpg"}
                alt={singleNews.title || "Imagen no disponible"}
                className="w-full h-full object-cover"
                sizes="(max-width: 768px) 50vw, (max-width: 1200px) 70vw, 760px"
              />
            </div>

            <div className="px-4 py-2 grid auto-rows-min h-full">
              <p className="text-sm bg-dark02 text-white inline-block px-3 py-1 mb-4 w-fit">
                {singleNews.categoryName}
              </p>
              <h3 className="text-lg font-bold text-dark01 line-clamp-2 min-h-[3rem] uppercase">
                {singleNews.title}
              </h3>

              <div className="mx-[-1em]">
                <div className="px-4 flex justify-between items-end mt-3 text-dark01 border-t border-gray-300 pt-2">
                  <span className="text-sm ">{formatDate}</span>
                  <Link
                    href={newsLink}
                    className="text-sm hover:bg-light01 flex items-center gap-1"
                  >
                    {`SEGUIR LEYENDO`}
                    <IconSprite id="ic_arrow_right" className="w-3 h-3" />
                  </Link>
                </div>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
